import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faGamepad,
  faUser,
  faBell,
  faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons';
import Avatar from '../shared/Avatar';
import { useEffect, useState } from 'react';
import { getSubscriber, logout } from '../../apiservices/LocalStorageService';
import './Sidebar.css';

const navItems = [
  { path: '/dashboard/home', label: 'Home', icon: faHome },
  { path: '/dashboard/games', label: 'My Games', icon: faGamepad },
  { path: '/dashboard/profile', label: 'Profile', icon: faUser },
  {
    path: '/dashboard/notifications',
    label: 'Notifications',
    icon: faBell,
    badge: 0,
  },
];

interface SidebarProps {
  onNavClick?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onNavClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState<{ firstName?: string; lastName?: string }>(
    {}
  );

  useEffect(() => {
    const sub = getSubscriber();
    if (sub) setUser(sub);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const displayName =
    [user.firstName, user.lastName].filter(Boolean).join(' ') || 'User';

  return (
    <aside className="sidebar">
      <div className="sidebar__logo">
        <img src="/funhives.png" alt="FunHives" className="sidebar__logo-img" />
      </div>

      <div className="sidebar__user">
        <Avatar fallback={displayName[0]} size="sm" />
        <div>
          <div className="sidebar__user-name">{displayName}</div>
          <div className="sidebar__user-xp">⚡ 1,240 XP</div>
        </div>
      </div>

      <nav className="sidebar__nav">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={onNavClick}
            className={`sidebar__link ${location.pathname === item.path ? 'sidebar__link--active' : ''}`}
          >
            <FontAwesomeIcon icon={item.icon} className="sidebar__link-icon" />
            <span>{item.label}</span>
            {item.badge > 0 && (
              <span className="sidebar__badge">{item.badge}</span>
            )}
          </Link>
        ))}
      </nav>

      <button className="sidebar__logout" onClick={handleLogout}>
        <FontAwesomeIcon
          icon={faRightFromBracket}
          className="sidebar__link-icon"
        />
        <span>Logout</span>
      </button>
    </aside>
  );
};

export default Sidebar;
